import axios from "axios";
import { getWsToken } from "@services/account/auth";

export async function getLoginTrades(query) {
    const res = await getWsToken();
    const config = {
        params: query,
        headers: {
            Token: res.data.ws_token,
        },
    };

    return axios.get(
        (document.querySelector("body").getAttribute("socketapi") ||
            process.env.VUE_APP_SOCKET_API) +
                "/calculationResult/calculatedTradeByLoginAndSymbol",
        config
    );
}
